import { Breadcrumb, Table, Typography } from 'antd'

import { MONO_STYLE } from '@/components/common/MonoId'
import { useClusters } from '@/hooks/useClusters'
import { useTableRowNavigation } from '@/hooks/useTableRowNavigation'
import { getPersistedPageSize, tablePaginationConfig } from '@/types/api'

export default function ClustersListPage() {
  const onRow = useTableRowNavigation('clusters')
  const clusters = useClusters()

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: 'Clusters' }]}
      />
      <Table
        dataSource={clusters}
        rowKey="id"
        onRow={onRow}
        pagination={tablePaginationConfig({
          pagination: { pageSize: getPersistedPageSize() },
        })}
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 160,
            render: (id: string) => (
              <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
                {id.slice(0, 8)}...
              </Typography.Text>
            ),
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name: string) => (
              <Typography.Text copyable={{ text: name }}>
                {name}
              </Typography.Text>
            ),
          },
          {
            title: 'DC ID',
            dataIndex: 'dcId',
            key: 'dcId',
            render: (id: string) => (
              <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
                {id.slice(0, 8)}...
              </Typography.Text>
            ),
          },
        ]}
      />
    </div>
  )
}
